import { Columns } from '@shared/interfaces/table/column-config';
import { MeterDto } from '@app/api/nts';
import { StatusCellComponent } from '@shared/components/table/cells/status-cell/status-cell.component';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';

export const meterInformationMasterData: Columns<MeterDto>[] = [
  {
    title: 'Indsættelsesdato',
    key: 'commissioningDate',
    cellRenderer: DateCellComponent
  },
  {
    title: 'meter.meterNumber',
    key: 'meterNumber'
  },
  {
    title: 'meter.alternativeMeterNumber',
    key: 'alternateMeterNumber'
  },
  {
    title: 'meter.serialNumber',
    key: 'serialNumber'
  },
  {
    title: 'meterFrame.status',
    key: 'status',
    cellRenderer: StatusCellComponent,
    cellRendererParams: {
      notspecified: { color: 'bg-yellow-500', label: 'status.unknown' },
      active: { color: 'bg-green-500', label: 'status.active' },
      passive: { color: 'bg-yellow-500', label: 'status.passive' },
    }
  },
  {
    title: 'meter.acquisitionDate',
    key: 'acquisitionDate',
    cellRenderer: DateCellComponent
  },
  {
    title: 'meter.accuracyClass',
    key: 'accuracyClass',
    cellRenderer: TranslateCellComponent,
    cellRendererParams: {
      notspecified: 'meter.accuracyClasses.notspecified',
      a: 'meter.accuracyClasses.a',
      b: 'meter.accuracyClasses.b',
      c: 'meter.accuracyClasses.c',
      zeropointtwos: 'meter.accuracyClasses.zeropointtwos',
      zeropointfive: 'meter.accuracyClasses.zeropointfive'
    }
  },
  {
    title: 'meter.measurementPrinciple',
    key: 'measurementPrinciple'
  },
  {
    title: 'meter.comment',
    key: 'comment'
  },
  {
    title: 'meter.ctTurnOverRatio',
    key: 'ctTurnOverRatioDisplayValue'
  },
  {
    title: 'meter.vtTurnOverRatio',
    key: 'vtTurnOverRatioDisplayValue'
  },
  {
    title: 'meteringpoint.meter.createcontrolmeter.relativedeviation',
    key: 'relativeDeviation',
    cellRenderer: DecimalCellComponent,
    hideIf: (data) => (data.verificationMeter !== true),
  },
  {
    title: 'meteringpoint.meter.createcontrolmeter.absolutedeviation',
    key: 'absoluteDeviation',
    cellRenderer: DecimalCellComponent,
    hideIf: (data) => (data.verificationMeter !== true),
  },
]
